module.exports = __webpack_public_path__ + "static/media/as-alonso-stanzani-advogados-associados-pasta-personalizada.88addd08.jpg";